import { render, staticRenderFns } from "./EditCrmModal.vue?vue&type=template&id=12b18334&scoped=true&"
import script from "./EditCrmModal.vue?vue&type=script&lang=js&"
export * from "./EditCrmModal.vue?vue&type=script&lang=js&"
import style0 from "./EditCrmModal.vue?vue&type=style&index=0&id=12b18334&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b18334",
  null
  
)

export default component.exports